import { useIntl } from 'react-intl';
import { Prompt } from 'sonata-react-components';

import { GroupingPortal } from '../GroupingModal/GroupingPortal';
import { groupingMessages } from '../groupingMessages';

import type { GroupReferences } from '../../domain/grouping.types';

export interface DeleteGroupPromptProps {
  groupName: string;
  onCancel: () => void;
  onConfirm: () => void;
  references: GroupReferences;
}

/** Confirmation shown before deleting a group that ads or temporal pacing still reference. */
export function DeleteGroupPrompt({ groupName, onCancel, onConfirm, references }: Readonly<DeleteGroupPromptProps>) {
  const { formatMessage } = useIntl();

  return (
    <GroupingPortal>
      <Prompt
        buttons={[
          {
            id: 'deleteGroupPrompt-cancel',
            onClick: onCancel,
            shape: 'squareRounded',
            text: formatMessage(groupingMessages.cancel),
            type: 'secondary'
          },
          {
            id: 'deleteGroupPrompt-confirm',
            onClick: onConfirm,
            shape: 'squareRounded',
            text: formatMessage(groupingMessages.deleteGroup),
            type: 'primary'
          }
        ]}
        closePrompt={onCancel}
        description={formatMessage(groupingMessages.deletePromptDescription, { ...references })}
        icon="fa-regular fa-trash"
        id="deleteGroupPrompt"
        title={formatMessage(groupingMessages.deletePromptTitle, { name: groupName })}
        variant="warning"
        width="480px"
      />
    </GroupingPortal>
  );
}
